import { Thread_Type_Enum } from '@gql'

export interface ThreadTypeBadgeInfo {
  labelKey:
    | 'ThreadType.short.Tactical'
    | 'ThreadType.short.Governance'
    | 'ThreadType.short.unknown'
  colorScheme: 'teal' | 'purple' | 'gray'
}

// Pure mapping, isolated from React so it can be tested without rendering.
export function threadTypeBadge(
  type: Thread_Type_Enum | null | undefined
): ThreadTypeBadgeInfo {
  switch (type) {
    case Thread_Type_Enum.Tactical:
      return { labelKey: 'ThreadType.short.Tactical', colorScheme: 'teal' }
    case Thread_Type_Enum.Governance:
      return { labelKey: 'ThreadType.short.Governance', colorScheme: 'purple' }
    default:
      // Unknown/missing type: neutral fallback, never throws.
      return { labelKey: 'ThreadType.short.unknown', colorScheme: 'gray' }
  }
}
